// Vite-only env reads, isolated so jest (CJS) never parses `import.meta`.
// Tests moduleNameMapper-mock this module; app code imports the constants.
export const VITE_DEV: boolean = import.meta.env.DEV;
export const VITE_PARROT_API_BASE_URL: string | undefined = import.meta.env
  .VITE_PARROT_API_BASE_URL;
// Standalone-deployment target (app-prod / app-staging) — see api/base.ts.
export const VITE_PARROT_TARGET: string | undefined = import.meta.env
  .VITE_PARROT_TARGET;
// Vite base path: "/app/" (droplet-embedded) or "/" (standalone). Drives the
// router basename + the bad-auth redirect.
export const VITE_BASE_URL: string = import.meta.env.BASE_URL;
